import styled from 'styled-components'
import { breakpointFrom } from 'utils/breakpoints'

export const StyledDisclaimer = styled.p`
  ${({ theme }) => theme.typography.SmBody3};
  text-align: center;
  opacity: 0.48;
  margin-top: ${({ theme }) => theme.space[4]};

  ${({ theme }) => breakpointFrom(theme.breakpoints.md)} {
    margin-top: ${({ theme }) => theme.space[5]};
    ${({ theme }) => theme.typography.MedBody3};
  }

  ${({ theme }) => breakpointFrom(theme.breakpoints.lg)} {
    ${({ theme }) => theme.typography.LrgBody3};
  }

  ${({ theme }) => breakpointFrom(theme.breakpoints.xl)} {
    ${({ theme }) => theme.typography.XLBody3};
  }
`
